export default __webpack_public_path__ + "images/0799a2d3107c78a9b45e13188059d0d4.svg";